import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import OrderWizardPage from '@/features/orders/order-wizard-page'

export const Route = createFileRoute('/_authenticated/orders/new')({
  component: () => (
    <RequirePermission permission='orders.create'>
      <OrderWizardPage />
    </RequirePermission>
  ),
})
